<script lang="ts">
import { CARD_ART_HEIGHT } from '../ui/art';

export default {
  name: 'ArtSuccess',
  data() {
    return {
      CARD_ART_HEIGHT
    };
  }
};
</script>

<template>
  <img src="/add-to-transcript/art-success.gif" :height="CARD_ART_HEIGHT" />
</template>
